// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__vbZnK","location":"Header_location__dAp1U"};